/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { getAuthToken } from '../helper/storage'

export default function PublicRoute({ children }) {
  const navigate = useNavigate()
  // const url = location?.pathname

  // const authToken = getAuthToken()

  // useEffect(() => {
  //   if (authToken) {
  //     // setloggedin(true)
  //     navigate('/')
  //   }
  // }, [authToken])

  return <React.Suspense fallback={<>...</>}>{children}</React.Suspense>
}
